export default {"src":"/_next/static/media/unarchive.78303b48.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};